import { useEffect, useMemo, useState } from "react";
import ChatbotDefaultIcon from "./GeneralPreview/ChatbotBody/ChatbotDefaultIcon";

const ChatbotIcon = ({
  chatbotSettings,
  chatbotAppearance,
  chatIcon = false,
}: {
  chatbotSettings: any;
  chatbotAppearance: any;
  chatIcon?: boolean;
}) => {
  const newChatbotIcon = useMemo(() => {
    if (chatbotSettings.chatbotIcon) {
      const parser = new DOMParser();
      const svgDocument = parser.parseFromString(
        chatbotSettings.chatbotIcon,
        "image/svg+xml"
      );

      const pathElements = svgDocument.querySelectorAll("path");
      for (const pathElement of pathElements) {
        const fillAttribute = pathElement.getAttribute("fill");
        if (fillAttribute && fillAttribute !== "none") {
          pathElement.setAttribute(
            "fill",
            chatbotAppearance?.["cuvo-chatbot-bot-icon-fg-color"]
          );
        }
      }

      return new XMLSerializer().serializeToString(svgDocument);
    }
  }, [
    chatbotSettings.chatbotIcon,
    chatbotAppearance?.["cuvo-chatbot-bot-icon-fg-color"],
  ]);

  const [svgContent, setSvgContent] = useState<any>(null);

  useEffect(() => {
    const fetchSvg = async () => {
      const imgPath = chatbotSettings.chatbotIcon
        ? chatbotSettings.chatbotIcon
        : "";
      // "https://dashboard-cuvo-upload-photos.s3.amazonaws.com/product_6d414070-8396-11ee-a0ed-f3e6d67f790f/Demo1/logo.png";
      const fileExtension = getFileExtension(imgPath);
      if (fileExtension != "svg") {
        setSvgContent(
          chatbotSettings.chatbotIcon ? chatbotSettings.chatbotIcon : ""
        );
      } else {
        try {
          const response = await fetch(
            chatbotSettings.chatbotIcon ? chatbotSettings.chatbotIcon : ""
          );

          if (!response.ok) {
            throw new Error(`Failed to fetch SVG. Status: ${response.status}`);
          }
          const svgText = await response.text();
          setSvgContent(`data:image/svg+xml;base64,${btoa(svgText)}`);
        } catch (error) {
          // console.error("Error fetching SVG:", error);
        }
      }
    };

    fetchSvg();
  }, [chatbotSettings]);
  const getFileExtension = (url: any) => {
    const parts = url.split(".");
    if (parts.length > 1) {
      return parts[parts.length - 1];
      // eslint-disable-next-line @typescript-eslint/tslint/config
    } else {
      return null;
    }
  };
  // console.log(chatbotSettings, "chatbotSettings");
  return (
    <>
      {!chatbotSettings.chatbotIcon && (
        <ChatbotDefaultIcon
          width="20px"
          // color={chatbotAppearance?.["cuvo-chatbot-bot-icon-fg-color"]}
        />
      )}

      {chatbotSettings.chatbotIcon && (
        <img
          style={{ width: "20px" }}
          src={
            chatIcon ? chatbotSettings.chatIcon : svgContent
            //chatbotSettings.chatbotIcon
          }
        />
      )}
    </>
  );
};

export default ChatbotIcon;
